import React, {
    ForwardedRef,
    forwardRef,
    PropsWithChildren,
    useContext,
    useEffect,
    useImperativeHandle,
    useRef,
    useState
} from 'react';
import AccountSelect from './accountSelect';
import {ActivateHandle, SelectableAccount} from '../../util/interfaces';
import {AppContext} from '../misc/appContext';
import Account from '../../models/accountModel';
import {onPopupClosed, requestOpenPopup} from "../../util/popupUtil";

interface Props {
    onImport: (accountId: string) => void;
    loading: boolean;
    title: string;
}

function AccountSelectController(props: PropsWithChildren<Props>, ref: ForwardedRef<ActivateHandle>) {
    const context = useContext(AppContext);
    const {onImport, loading, title, children} = props;
    const {accounts, account} = context.accountContext;
    const [isActive, setIsActive] = useState(false);
    const [accountId, setAccountId] = useState('');
    const popupId = useRef<string | null>(null);

    function onActivate() {
        popupId.current = requestOpenPopup(activate, true);
    }

    function activate() {
        setIsActive(true);
        setInitialAccount();
    }

    function getAccounts(): SelectableAccount[] {
        const selectableAccounts = accounts.filter(account => context.accountContext.account !== account)
        return selectableAccounts.map((account: Account) => {
            const {selectablePlatformLabel, id} = account;

            return {label: selectablePlatformLabel, id};
        })
    }

    function _onImport() {
        if (!accountId.length || !account) return;
        onImport(accountId);
    }

    function setInitialAccount() {
        const accounts = getAccounts();
        setAccountId(accounts[0].id)
    }

    function onDeactivate() {
        setIsActive(false);
        setAccountId('');
        if (popupId.current) onPopupClosed(popupId.current);
    }

    function onChangeAccount(accountId: string) {
        setAccountId(accountId)
    }

    useEffect(() => {
        return function () {
            if (popupId.current) onPopupClosed(popupId.current);
        }
    }, []);

    useImperativeHandle(ref, () => ({
        activate: onActivate,
        close: onDeactivate,
    }));

    return <AccountSelect active={isActive} onDeactivate={onDeactivate} onImport={_onImport} loading={loading}
                          onChangeAccount={onChangeAccount} accounts={getAccounts()} currentAccount={accountId}
                          children={children} title={title}/>
}

export default forwardRef<ActivateHandle, PropsWithChildren<Props>>(AccountSelectController);